// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "seatsLegendModal__title-1rUra";
var _3 = "seatsLegendModal__container-34RgC";
var _4 = "seatsLegendModal__paper-1cI2d";
var _5 = "seatsLegendModal__top_wrapper-GmuDZ";
var _6 = "seatsLegendModal__content-16MQ8";
export { _1 as "__esModule", _2 as "seatsLegendModal__title", _3 as "seatsLegendModal__container", _4 as "seatsLegendModal__paper", _5 as "seatsLegendModal__top_wrapper", _6 as "seatsLegendModal__content" }
export default { "__esModule": _1, "seatsLegendModal__title": _2, "seatsLegendModal__container": _3, "seatsLegendModal__paper": _4, "seatsLegendModal__top_wrapper": _5, "seatsLegendModal__content": _6 }
